import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = { redirectUri: string };
export type CreateInsuranceSessionResponse = { ignitionUri: string };

export const useCreateInsuranceSession = createMutation<
  CreateInsuranceSessionResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/customers/insurance/session',
      method: 'POST',
      data: {
        redirect_uri: variables.redirectUri,
      },
    })
      .then((response) => response.data.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
